import {
  Card,
  CardContent,
  Stack,
  Tooltip,
  Typography,
  type TypographyProps,
  styled,
  useTheme,
} from "@mui/material"
import { ClipBoardButton } from "@pharmupp/p3-front-commons"
import { useMemo } from "react"
import { useEmailInfo } from "./useEmailInfo"

export interface EmailContentProps {
  userFullName: string
  userEmail: string
}

const CSE_EMAIL = "supportadmin@hpal.fr"

export const EmailContent = (props: EmailContentProps) => {
  const pharmacieInfo = useEmailInfo()
  const { palette } = useTheme()
  const personnalInfo = useMemo(
    () => msgMail({ ...props, ...pharmacieInfo }),
    [props, pharmacieInfo],
  )

  return (
    <Stack gap={2}>
      <Typo fontWeight={500} sx={{ color: palette.branding.dark }}>
        L' email de ce collaborateur est déjà utilisé sur la plateforme HappyPal.
        Rapprochez-vous du support HappyPal en leur transmettant ces informations :{" "}
        <Typo fontWeight={500} color="error" component="span">
          {CSE_EMAIL}
        </Typo>
        <Tooltip title="Copier l'email">
          <ClipBoardButton
            label="Email"
            value={CSE_EMAIL}
            sx={{ color: palette.branding.light2 }}
          />
        </Tooltip>
      </Typo>
      <Card>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typo>
            <Tooltip title="Copier le corps du message">
              <ClipBoardButton
                label="Le contenu du message a été"
                value={personnalInfo}
                sx={{ color: palette.branding.light2, float: "right" }}
              />
            </Tooltip>
            {personnalInfo}
          </Typo>
        </CardContent>
      </Card>
    </Stack>
  )
}

interface ContentInfo extends EmailContentProps {
  connectedUserName: string
  pharmacieName: string
}

const msgMail = ({
  userFullName,
  userEmail,
  connectedUserName,
  pharmacieName,
}: ContentInfo) =>
  `Je fais partie du Groupement PharmUPP et je rencontre actuellement un problème d'activation de compte pour : ${userFullName} - Email : ${userEmail}

Il semble que l'email d'inscription soit déjà présent chez vous, mais pour une autre entité. Pouvez-vous faire le nécessaire pour nous permettre de lui ouvrir son accès CSE ?

Merci d'avance pour votre aide
Bien cordialement

${connectedUserName} - ${pharmacieName}
Groupement PharmUPP`

const Typo = styled(Typography)<TypographyProps>(({ theme: { typography } }) => ({
  fontSize: typography.pxToRem(14),
  lineHeight: typography.pxToRem(20),
  whiteSpace: "pre-line",
}))
